module.exports = __webpack_public_path__ + "img/sub-title2.0bc08660.png";